import { Box, LinearProgress, TableCell } from "@material-ui/core";
import TableRow from "@material-ui/core/TableRow";
import React from "react";

export const ReportBugsTableLoading = () => {
	return (
		<TableRow>
			<TableCell colSpan={7}>
				<Box py={19}>
					<LinearProgress />
				</Box>
			</TableCell>
		</TableRow>
	);
};
